import { lazy } from 'react'; 
import { MOD_USER_PROFILE } from '@/configs/ModulesConfig'; 

const AppUserProfile = lazy(() => import('./AppUserProfile')); 

const route = [ 
    {
        path: MOD_USER_PROFILE.base_path,
        element: <AppUserProfile />,
        auth: MOD_USER_PROFILE.app_user_auth
    }
];



export default route;